/**
 * Brazilian Portuguese (pt-BR) mappings for NBA Dashboard
 * Translations for both desktop and mobile NBA components
 */

export const nbaDashPtBR = {
  // Header & Navigation
  "Sports Hub • Basketball": "Centro Esportivo • Basquete",
  "NBA Terminal": "Terminal NBA",
  "Track live NBA games, monitor AI predictions, and stay close to league action worldwide.": "Acompanhe jogos ao vivo da NBA, monitore previsões da IA e fique próximo da ação da liga no mundo todo.",
  "NBA Dashboard": "Painel da NBA",
  "NBA Basketball": "Basquete da NBA",
  "Live scores, upcoming games, and real-time updates": "Placar ao vivo, próximos jogos e atualizações em tempo real",
  "Live scores & stats": "Placar ao vivo e estatísticas",

  // Beta Notice
  "All AI picks saved to chat history.": "Todas as apostas da IA salvas no histórico do chat.",
  "All AI picks saved to chat history": "Todas as apostas da IA salvas no histórico do chat",
  "Go to chat to dive deeper.": "Vá para o chat para se aprofundar.",
  "Go to chat to dive deeper": "Vá para o chat para se aprofundar",
  "v4 Beta": "v4 Beta",
  "Not all features available yet": "Nem todos os recursos disponíveis ainda",
  "v4 Beta • Not all features available yet": "v4 Beta • Nem todos os recursos disponíveis ainda",

  // Filters Section
  "Game Date": "Data do Jogo",
  "Date": "Data",
  "Status": "Status",
  "Filters": "Filtros",
  "Refresh": "Atualizar",
  "Loading...": "Carregando...",

  // Status Options
  "All Games": "Todos os Jogos",
  "Live Only": "Apenas Ao Vivo",
  "Upcoming": "Próximos",
  "Finished": "Finalizados",

  // Stats Bar Labels
  "Total Games": "Total de Jogos",
  "Total": "Total",
  "Live": "Ao Vivo",
  "Next": "Próximos",
  "Done": "Concluídos",

  // Game Status
  "LIVE": "AO VIVO",
  "FINAL": "FINAL",
  "Q1": "Q1",
  "Q2": "Q2",
  "Q3": "Q3",
  "Q4": "Q4",
  "OT": "PRORR",
  "PPD": "ADI",  // Postponed - Adiado
  "DELAYED": "ATRASADO",
  "CANC": "CANC",  // Canceled - Cancelado
  "TBD": "A definir",
  "Final": "Final",

  // Empty States
  "No Games Found": "Nenhum Jogo Encontrado",
  "No games found for this date": "Nenhum jogo encontrado para esta data",
  "Try selecting a different date": "Tente selecionar uma data diferente",
  "Error Loading Games": "Erro ao Carregar Jogos",
  "Failed to load games. Please try again.": "Falha ao carregar jogos. Por favor, tente novamente.",
  "Try Again": "Tentar Novamente",
  "Retry": "Tentar Novamente",

  // Loading States
  "Loading NBA games...": "Carregando jogos da NBA...",
  "Loading games...": "Carregando jogos...",

  // Team Labels
  "Visitors": "Visitantes",
  "Home": "Casa",
  "V": "V",  // Visitors abbreviation
  "H": "C",  // Home abbreviation - Casa
  "Q": "Q",  // Quarter abbreviation

  // Game Card Labels
  "NBA": "NBA",
  "VS": "VS",

  // Action Buttons
  "Predict": "Prever",
  "PREDICT": "PREVER",
  "Selected": "Selecionado",
  "SELECTED": "SELECIONADO",
  "Cooldown": "Recarga",
  "COOLDOWN": "RECARGA",
  "Odds": "Cotações",
  "VIEW ODDS": "VER COTAÇÕES",
  "PREDICT LIVE": "PREVER AO VIVO",

  // Prediction Section
  "AI Pick": "Escolha da IA",
  "AI Pick:": "Escolha da IA:",
  "Analyzing...": "Analisando...",
  "Predicting...": "Prevendo...",
  "Confidence Level": "Nível de Confiança",
  "Confidence Level:": "Nível de Confiança:",
  "HIGH": "ALTO",
  "MED": "MÉDIO",
  "LOW": "BAIXO",
  "confidence": "confiança",
  "Reasoning": "Raciocínio",
  "Reasoning:": "Raciocínio:",
  "Analyze in Chat": "Analisar no Chat",
  "Analyze in Chat →": "Analisar no Chat →",
  "More in Chat": "Mais no Chat",

  // Prediction Bar (Desktop)
  "Game Selected (Max 5)": "Jogo Selecionado (Máx 5)",
  "Games Selected (Max 5)": "Jogos Selecionados (Máx 5)",
  "7 coins/game": "7 moedas/jogo",
  "coins total": "moedas no total",
  "Clear": "Limpar",
  "Predict Winners": "Prever Vencedores",

  // Mobile Prediction Bar - specific translations
  "7 coins/game •": "7 moedas/jogo •",

  // Usage States
  "Need": "Precisa de",
  "Star Coins (You have": "Moedas Estrela (Você tem",
  "Insufficient Star Coins. Need": "Moedas Estrela insuficientes. Precisa de",
  "coins.": "moedas.",

  // Error Messages
  "Failed to load games": "Falha ao carregar jogos",

  // Refund Notice
  "💰": "💰",

  // Close/Navigation
  "Close": "Fechar",
  "Back": "Voltar",

  // Time Display
  "ET": "ET",

  // Quarter Scores Header
  "Quarter": "Quarto",
  "Quarters": "Quartos",

  // Upgrade Notice
  "Upgrade to Premium": "Atualizar para Premium",
  "Get unlimited predictions": "Obtenha previsões ilimitadas",

  // Chat Analysis
  "Analyze this NBA prediction:": "Analisar esta previsão da NBA:",
  "Can you provide a deeper analysis of this matchup?": "Você pode fornecer uma análise mais profunda desta partida?",
  "Prediction:": "Previsão:",

  // SEO Meta
  "NBA Dashboard - Live Scores & Games | PickAI": "Painel da NBA - Placar Ao Vivo e Jogos | PickAI",
  "Track live NBA games, scores, and predictions with real-time updates": "Acompanhe jogos ao vivo da NBA, placares e previsões com atualizações em tempo real",
  "nba, basketball, live scores, predictions": "nba, basquete, placar ao vivo, previsões",

  // League Display
  "Standard": "Padrão",
  "Vegas": "Vegas",
  "Utah": "Utah",
  "Sacramento": "Sacramento"
};
